module.exports = __webpack_public_path__ + "img/check.b601266d.png";